import styled from 'styled-components';
import { Button, IconOpenInNew } from 'cdk-radial';
import { environmentURLs } from '../../common/CaptureEnvironment';
import { Constants } from '../../../constants/constants';
import { sendAmplitudeData } from '../../../utils/amplitude';
import { AMPLITUDE_EVENTS } from '../../../constants/amplitudeConstants';

const MPButtonBase = styled(Button)`
  width: fit-content;
  float: right;
  color: #ffffff;
  background-color: rgb(25, 111, 225) !important;
`;
const MPButtonIcon = styled(IconOpenInNew)`
  width: 1.25rem;
  height: 1.25rem;
`;

export default function BrowseMarketplaceButton() {

  const handleClick = (e) => {
    e.stopPropagation();
    sendAmplitudeData(AMPLITUDE_EVENTS.BROWSE_MARKETPLACE, {});
    window.open(
      environmentURLs.REACT_APP_MARKETPLACE_URL,
      '_blank',
      'noopener'
    );
  };

  return (
    <MPButtonBase
      onClick = {(event) => handleClick(event)}
      text={Constants.BROWSE_FORTELLIS_MARKETPLACE}
      icon={<MPButtonIcon />}
      isIconTrailing={true}
    />
  )
}
